import { Box, Skeleton } from '@ltvco/refresh-lib/theme';

const SKELETON_ITEMS = 20;

export const ConversationListSkeleton = () => (
  <Box sx={{ width: '100%', px: 1 }}>
    {Array.from({ length: SKELETON_ITEMS }).map((_, i) => (
      <Box
        key={i}
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 1,
          px: 1,
          ml: 0.5,
        }}
      >
        <Skeleton
          variant="rounded"
          height={20}
          sx={{
            width: `${60 + (i % 3) * 15}%`,
            borderRadius: 1,
          }}
        />
      </Box>
    ))}
  </Box>
);
